/**
 * Nettoyage centralisé des caches JS du navigateur / WebView.
 * - Cache API (fetch caches / SW caches)
 * - Service Workers
 * - sessionStorage (en préservant les clés d'auth Supabase)
 *
 * Utilisé à la fois par le check de version natif (Capacitor),
 * le polling de version web et le handler d'erreur de chunk Vite.
 */
export async function clearAppCaches(): Promise<void> {
  try {
    if (typeof window === 'undefined') return;

    // 1. Cache API
    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((n) => caches.delete(n)));
        console.log('[clearAppCaches] Cache API cleared');
      } catch (e) {
        console.warn('[clearAppCaches] Cache API clear failed:', e);
      }
    }

    // 2. Service Workers
    if ('serviceWorker' in navigator) {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
        if (regs.length > 0) {
          console.log(`[clearAppCaches] ${regs.length} service worker(s) unregistered`);
        }
      } catch (e) {
        console.warn('[clearAppCaches] SW unregister failed:', e);
      }
    }

    // 3. sessionStorage — préserver les clés d'auth
    try {
      const preservePrefixes = ['sb-', 'supabase.auth'];
      const toRemove: string[] = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && !preservePrefixes.some((p) => key.includes(p))) {
          toRemove.push(key);
        }
      }
      toRemove.forEach((k) => sessionStorage.removeItem(k));
    } catch (e) {
      console.warn('[clearAppCaches] sessionStorage purge failed:', e);
    }
  } catch (e) {
    console.error('[clearAppCaches] Unexpected error:', e);
  }
}
